import { SxProps } from '@mui/material'
import { Box } from '@mui/system'

interface ImageProps {
  src: string
  width?: string
  height?: string
  title?: string
  isCover?: boolean
  ratio?: number
  sx: SxProps
}

const Image = ({
  src,
  width,
  height,
  title,
  isCover = false,
  ratio,
  sx,
}: ImageProps) => {
  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        ...sx,
        ...(ratio && {
          paddingTop: `${ratio}%`,
        }),
        ...(!ratio && {
          width: `${width}px`,
          height: `${height}px`,
        }),
      }}
    >
      <img
        src={src}
        alt={title}
        width={width}
        height={height}
        style={{
          width: '100%',
          height: '100%',
          ...(isCover ? { objectFit: 'cover' } : { objectFit: 'contain' }),
          ...(ratio && {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }),
        }}
      />
    </Box>
  )
}

export default Image
